import React, { Component } from "react"
import { Button, Modal } from "react-bootstrap"
import Select from "react-select"
import ClientPortalEmployeeAccessLevelAreaTypes from "../Types/ClientPortalEmployeeAccessLevelAreaTypes"
import ServiceAreaTypes from "../Types/ServiceAreaTypes"
import EALAService from "../Utils/EALAService"
import mutator from "src/utilities/mutator"
import serviceAreaBoiler from "../Utils/BoilerPlates/serviceAreaBoiler"
import "./EditDefaultArea.css"

interface Props {
    manageParentState: Function
    callParentFunction: Function
    defaultEALA: ClientPortalEmployeeAccessLevelAreaTypes
    AccessLevelID: number
}

interface State {
    selectedServiceArea: ServiceAreaTypes
}

class EditDefaultArea extends Component<Props, State> {

    state = {
        selectedServiceArea: { ...serviceAreaBoiler }
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: { key: string, value?: any }[]) => {
        this.setState(mutator.mutate(this.state, keys))
    }

    render() {

        const { manageParentState, callParentFunction, defaultEALA, AccessLevelID } = this.props
        const { selectedServiceArea } = this.state
        const { lookupHashTableItem, getAvailableAreasScopedByProfitCenterID } = EALAService
        const availableAreas = getAvailableAreasScopedByProfitCenterID(AccessLevelID, defaultEALA.ProfitCenterID)
        const bucketItem = lookupHashTableItem("serviceAreaTable", defaultEALA.ServiceAreaID)
        const canSave = selectedServiceArea.ServiceAreaID > -1 && (selectedServiceArea.ServiceAreaID !== defaultEALA.ServiceAreaID)
        const currentDefaultServiceArea = bucketItem ? bucketItem[1] : serviceAreaBoiler

        // console.log("EditDefaultArea props", this.props)
        // console.log("EditDefaultArea state", this.state)
        // console.log("EditDefaultArea bucketItem", bucketItem)

        return (
            <div className="EditDefaultArea">
                <Modal
                    id="edit-default-area-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                    size="sm"
                >
                    <Modal.Header>
                        <div className="EditDefaultAreaModalHeader">
                            <span className="material-icons">home</span>
                            <p>Choose a new default service area</p>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="EditDefaultAreaModalBody">
                            <Select
                                placeholder={"End user"}
                                value={{ label: !canSave ? currentDefaultServiceArea.ServiceAreaLongDesc : selectedServiceArea.ServiceAreaLongDesc }}
                                options={availableAreas.map((area) => ({ value: area.id, label: area.text }))}
                                onChange={(item: { label: string, value: number }) => {
                                    const serviceAreaId = item.value
                                    const bucketItem = lookupHashTableItem("serviceAreaTable", serviceAreaId)
                                    if (bucketItem) {
                                        this.manageState([{ key: "selectedServiceArea", value: bucketItem[1] }])
                                    }
                                }}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="EditDefaultAreaModalFooter">
                            <Button variant="secondary" onClick={() => manageParentState([{ key: "editDefaultArea", value: false }])}>Cancel</Button>
                            <Button variant="primary" disabled={!canSave} onClick={() => {
                                const newDefaultArea = { ...defaultEALA, ...{ ServiceAreaID: selectedServiceArea.ServiceAreaID } }
                                callParentFunction("editEALAS", [newDefaultArea], "editDefaultAreaBusy", true)
                                manageParentState([{ key: "editDefaultArea", value: false }])
                            }}>Save</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default EditDefaultArea